import React from 'react';
import { SC_TooltipSlider } from './TooltipSlider.styled';

export interface UHCTooltipSliderProps {
    children?: React.ReactNode
}

const UHCTooltipSlider: React.FC<UHCTooltipSliderProps> = ({ children }) => {
    return (
        <SC_TooltipSlider data-testid='id-div-test'>
            {children}
        </SC_TooltipSlider>
    );
};

export default UHCTooltipSlider;
